import { Sprite } from 'pixi.js';

import { Shared } from '../../App';
import { NineSliceButton } from './NineSliceButton';

const defaultOpts = {
    startHidden: false,
};

export type CloseButtonOpts = typeof defaultOpts;

export class CloseButton extends NineSliceButton
{
    constructor(opts: Partial<CloseButtonOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };
        const icon = Sprite.from(Shared.assets.getTexture('icon-close'));

        super({
            icon,
            accessibleTitle: 'Back',
            bgAsset: 'button-ninesliced-magenta',
            w: 120,
            h: 120,
            startHidden: o.startHidden,
        });
    }
}
